import { FC } from 'react';
import styles from './index.module.less';
import { getActivityStatus, getFormatedTimeObj } from 'base/utils/flashsale';
import Countdown, { RenderParamType } from '@base/lib/Countdown';
import { useStore } from 'base/store';
import { ISFSProductProps } from '@base/shop/SFSCard/SFSProduct';
import { useTrans } from 'base/utils/i18n';
import cn from 'classnames';

function renderTime(time: number): string {
    const o = getFormatedTimeObj(time);
    return `${o.date}, ${o.time}`;
}

const TimeWrapper: FC = ({ children }) => {
    return (
        <div className={cn(styles['activity-time'], 'g-activity-time')}>
            {children}
        </div>
    );
};

export const ActivityTime: FC<ISFSProductProps> = props => {
    const {
        currentTime,
        data: {
            startTime,
            endTime,
            activityStock
        }
    } = props;

    const status = getActivityStatus(currentTime, startTime, endTime);
    const { userStore } = useStore();
    const { t } = useTrans();

    if (status === 'notStarted') {
        return (
            <TimeWrapper>
                <span className={cn(styles.label, 'g-sfs-label')}>{t('web_time_starts_on')}</span>
                <span className={cn(styles.time, 'g-sfs-time')}>{renderTime(startTime)}</span>
            </TimeWrapper>
        );
    }
    if (status === 'ended') {
        return (
            <TimeWrapper>
                <span className={cn(styles.label, 'g-sfs-label')}>{t('web_time_ended_at')}</span>
                <span className={cn(styles.time, 'g-sfs-time')}>{renderTime(endTime)}</span>
            </TimeWrapper>
        );
    }

    if (activityStock === 0) {
        return (
            <TimeWrapper>
                <span className={cn(styles.label, 'g-sfs-label')}>Sold Out</span>
            </TimeWrapper>
        );
    }

    return (
        <TimeWrapper>
            <span className={cn(styles.label, 'g-sfs-label')}>{t('web_time_ends_in')}</span>
            <Countdown
                className={cn(styles.countdown, 'g-sfs-countdown')}
                endTime={endTime}
                isShowDay={true}
                render={(o: RenderParamType) => {
                    let arr: string[] = [];
                    if (Number(o.day) > 0) {
                        arr.push(`${o.day}`);
                    }
                    arr.push(`${o.hour}`);
                    arr.push(`${o.minute}`);
                    arr.push(`${o.second}`);

                    return arr.map(item => item).join(':')
                }}
                onUpdate={(container, lastSeconds) => {
                    if (lastSeconds === 0) {
                        userStore.fetchUserInfo();
                    }
                }}
            />
        </TimeWrapper>
    );
};